let vStore = null

export function setVuexStore (store) {
  vStore = store
}

export function getVuexStore () {
  return vStore
}

// helper for actions
export function dispatch (action, payload = {}) {
  if (!vStore) throw new Error('Vuex store not set')
  return vStore.dispatch(action, payload)
}

// helper for mutations
export function commit (mutation, payload) {
  if (!vStore) throw new Error('Vuex store not set')
  return vStore.commit(mutation, payload)
}

// helper for getters
export function getGetter (name) {
  if (!vStore) throw new Error('Vuex store not set')
  return vStore.getters[name]
}

// state (full or by key)
export function getState (key) {
  if (!vStore) throw new Error('Vuex store not set')
  return key ? vStore.state[key] : vStore.state
}

// helper to subscribe to state changes
export function subscribeState (key, callback) {
  if (!vStore) throw new Error('Vuex store not set')

  const unwatch = vStore.watch(
    (state) => (key ? state[key] : state),
    (newVal) => {
      callback(newVal)
    },
    { deep: true }
  )

  return unwatch // call this to unsubscribe
}



// WEBPACK FOOTER //
// ./src/react-component/reactStore/vuexBridge.js